import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

export const useUpdateGroupTaskMutation = getWrappedUseMutation(apiClient.ForumGroupTasks.task.put);
